import type { Permissao } from '@metaepi/shared';
import { ShieldX } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link, Navigate, Outlet, useLocation } from 'react-router';
import { Carregando } from '../components/ui';
import { useSessao } from '../features/auth/contexto';

/** Só deixa passar quem está logado e sem pendências de primeiro acesso. */
export function ExigirLogin() {
  const { conta, carregando, temPendencias, motivoSaida } = useSessao();
  const { pathname } = useLocation();

  if (carregando) {
    return (
      <div className="mx-auto mt-24 w-full max-w-md p-4">
        <Carregando rotulo="Verificando sua sessão…" />
      </div>
    );
  }
  if (!conta) {
    const parametros = new URLSearchParams();
    if (pathname !== '/') parametros.set('volta', pathname);
    if (motivoSaida) parametros.set('motivo', motivoSaida);
    const consulta = parametros.toString();
    return <Navigate to={`/entrar${consulta ? `?${consulta}` : ''}`} replace />;
  }
  if (temPendencias) return <Navigate to="/primeiro-acesso" replace />;
  return <Outlet />;
}

/** Tela de "sem permissão" quando o perfil não pode ver a página (a API também bloqueia). */
export function ExigirPermissao({
  permissao,
  children,
}: {
  permissao: Permissao;
  children: ReactNode;
}) {
  const { pode } = useSessao();
  if (pode(permissao)) return children;
  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4">
      <h1 className="text-2xl font-bold text-texto">Acesso não permitido</h1>
      <div className="flex items-center gap-3 text-texto-suave">
        <ShieldX className="size-6" aria-hidden="true" />
        <p>Seu perfil não tem permissão para esta página.</p>
      </div>
      <Link to="/" className="text-sm font-medium text-primaria hover:underline">
        Voltar ao início
      </Link>
    </div>
  );
}
